import axios, { Axios } from "axios";
import LocalStorage from "../utils/LocalStorage";
import { refreshAccessToken } from "../actions";
import nprogress from "nprogress";
import "./nprogress.css"

const progressApi = axios.create();


// progressApi.defaults.timeout = 60000;
//api.defaults.baseURL = SERVER_BASE_URL;
progressApi.defaults.baseURL = process.env.REACT_APP_BASE_URL;
progressApi.interceptors.request.use(
    async config => {
        nprogress.inc();
        const token = LocalStorage.getToken()
        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'

        if(token){
            config.headers = {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
                'Language': lang
            }
        } else {
            config.headers = {
                'Accept': 'application/json',
                'Language': lang
            }
        }
        return config;
    },
    error => {
        nprogress.done();
        Promise.reject(error)
    });

progressApi.interceptors.response.use((response) => {
    nprogress.done();
    return response
}, async function (error) {
    if (error instanceof axios.Cancel) {
        // 这里处理取消请求的逻辑
        return console.log('请求被取消了：', error.message);
    }

    if (error.code === 'ECONNABORTED') {
        // 处理超时错误
        return Promise.reject(new Error('Request timed out, please try again later'));
    }

    const originalRequest = error.config;
    if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        await refreshAccessToken();
        return progressApi(originalRequest);
    }
    if (error?.response?.status === 401){
        window.open('/', '_self');
    }
    nprogress.done();
    return Promise.reject(error);
});

export default progressApi
